import { useState, useEffect } from 'react';
import './App.css';
import SingleCard from './SingleCard';
import Confetti from 'react-confetti'

const log = console.log;

const allCardImages = [
  { "src": "/img/mg-card-butternut.png", matched: false},
  { "src": "/img/mg-card-chuck.png", matched: false},
  { "src": "/img/mg-card-hetty.png", matched: false},
  { "src": "/img/mg-card-king.png", matched: false},
  { "src": "/img/mg-card-lemmy.png", matched: false},
  { "src": "/img/mg-card-melly.png", matched: false},
  { "src": "/img/mg-card-ms-cooper.png", matched: false},
  { "src": "/img/mg-card-narra.png", matched: false},
  { "src": "/img/mg-card-retta.png", matched: false},
  { "src": "/img/mg-card-tugs.png", matched: false},
  { "src": "/img/mg-card-wilma.png", matched: false}
]

function App() {
  
  const [sixCards, setSixCards] = useState([])
  const [cards, setCards] = useState([])
  const [turns, setTurns] = useState(0)
  const [choiceOne, setChoiceOne] = useState(null)
  const [choiceTwo, setChoiceTwo] = useState(null)
  const [disabled, setDisabled] = useState(false)
  const [matchCount, setMatchCount] = useState(0)
  const [winner, setWinner] = useState(false)
  
  // Pick six random cards from 'allCardImages' database:
  const pickSix = () => {
    let sixNums = []
    for (let i = 0; i < allCardImages.length; i++) {
      let randomNum = Math.floor(Math.random() * allCardImages.length)
      if (sixNums.length < 6 && !sixNums.includes(randomNum)) {
        sixNums.push(randomNum)
      }
    }
    setSixCards(sixNums.map((num) => {
      return allCardImages[num]
    }))
  }

  //create pairs and shuffle cards
  const shuffleCards = () => { 
    const shuffledCards = [...sixCards, ...sixCards]
      .sort(() => Math.random() - 0.5)
      .map((card) => ({ ...card, id: Math.random() }))
    
    setChoiceOne(null)
    setChoiceTwo(null)
    setCards(shuffledCards)
    setTurns(0)
    setMatchCount(0)
    setWinner(false)
  }

  
  useEffect(() => {
    pickSix()
  }, [cards])

  // start new game on load
  useEffect(() => {
    if (cards.length < 12) {
      shuffleCards()
    }
  }, [sixCards])

  // handle player's choice
  const handleChoice = (card) => {
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card)
  }

  //check if player has won
  useEffect(() => {
    if (matchCount === 6) {
      setWinner(true)
      if (localStorage.bestScore && localStorage.bestScore > turns) {
        localStorage.setItem('bestScore', turns)
      } else if (!localStorage.bestScore) {localStorage.setItem('bestScore', turns)}
          }
  },[matchCount])
  
  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true)
      if (choiceOne.src === choiceTwo.src) {
        setMatchCount(prevCount => prevCount + 1)
        
        setCards(prevCards => {
          return prevCards.map(card => {
            if (card.src === choiceOne.src) {
              return { ...card, matched: true }
            } else {
              return card
            }
          })
        })
        resetTurn()
      } else {
        setTimeout(() => resetTurn(), 1000)
      }
    }
  }, [choiceOne, choiceTwo])
  
    // reset choices and increase turn
  const resetTurn = () => {
    setChoiceOne(null)
    setChoiceTwo(null)
    setTurns(prevTurns => prevTurns + 1)
    setDisabled(false)
  }
  
  return (
    <div className="App">
      {winner && <Confetti />
      }
      <h1>Mellybean Match</h1>
      <button onClick={shuffleCards}>New Game</button>
      
      <div className="card-grid">
        {cards.map(card => (
          <SingleCard
            card={card}
            key={card.id}
            handleChoice={handleChoice}
            flipped={card === choiceOne || card === choiceTwo || card.matched}
            disabled={disabled}            
          />
        ))}
      </div>
      <h2>Turns: {turns}</h2>
      {localStorage.bestScore && <h2>Best Score: {localStorage.getItem('bestScore')}</h2>}
    </div>
  );
}

export default App;
